import _ from 'lodash';
import GraphqlBuilder from "utils/request/graphql/builder";
import QueryBookings from "graphql/queries/management/QueryBookings";
import { bookingConstants } from 'utils/constants/booking-constants'

export default class FetchManagementBookings {

	static fetch( { building = {}, floor = {}, room = {}, date, kind, subKind, status = [], callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		const graphqlBuilder = new GraphqlBuilder();

		const buildingGuid = _.get( building, 'guid', null );
		const floorGuid = _.get( floor, 'guid', null );
		const roomGuid = _.get( room, 'guid', null );
		
		const isCustom = kind === bookingConstants.CUSTOM;

		graphqlBuilder
			.addQuery( 'employee_bookings', QueryBookings, {
				building_guid: buildingGuid,
				floor_guid: floorGuid,
				room_guid: roomGuid,
				kind: kind,
				sub_kind: isCustom ? subKind : null,
				booking_date: date,
				status: status
			})
			.setResultPath( ['employee_bookings', 'employee_bookings'], {} )
			.setOnStart( () => {
				return this.onStart(callbackStart);
			} )
			.setOnError( result => {
				return this.onError(result, callbackError);
			} )
			.setOnSuccess( result => {
				return this.onSuccess(result, callbackSuccess);
			} )
			.execute();
	}
	
	static onError( result, callbackError = null ) {
		if( callbackError !== null && _.isFunction( callbackError ) ) {
			callbackError( result );
		}
	}

	static onStart( callbackStart = null ) {
		if( callbackStart !== null && _.isFunction( callbackStart ) ) {
			callbackStart();
		}
	}

	/**
	 * Function for creating the occupied timeslots by employee guid
	 * @param result
	 * @param callbackSuccess
	 */
	static onSuccess( result, callbackSuccess = null ) {
		if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
			callbackSuccess( result );
		}
	}
}
